wbApp.controller('CoursesCopyDetailCtrl', ['$scope', '$modal', 'courseSvc', 'tenantSettingSvc', 'courseScheduleSvc', 'courseRegistrationSvc',
    '$translate', '$timeout', 'messageBoxSvc', 'semesterSvc', 'holidayCalendarSvc', 'gridSortSvc',
function ($scope, $modal, courseSvc, tenantSettingSvc, courseScheduleSvc, courseRegistrationSvc,
    $translate, $timeout, messageBoxSvc, semesterSvc, holidayCalendarSvc, gridSortSvc) {

    // force refresh semesters
    semesterSvc.getAllAsync(true);
    
    var origCourseID = $scope.model.courseID;

    $scope.model.courseID = 0;
    $scope.lessons = [];
    $scope.students = [];
    $scope.courseCopyMode = true;

    var lastExpanded = {
        recurrenceInfo: {},
    };


    $scope.onSemesterChange = function (semesterID) {
        expandRecurrence($scope.model);
    }

    $scope.isBusy = true;

    $scope.studentsLoaded = false;
    $scope.recurrenceExpanded = false;

    function expandRecurrence(model) {
        var semester = semesterSvc.get(model.semesterID);

        if (!!semester && !!semester.holidayCalendarId) {
            holidayCalendarSvc.getById(semester.holidayCalendarId).$promise.then(function (holidayCalendar) {
                expandRecurrenceImpl(model, holidayCalendar.days || []);
            });
        }
        else {
            expandRecurrenceImpl(model, []);
        }
    }

    function expandRecurrenceImpl(model, holidays) {
        lastExpanded = {
            startDate: model.startDate,
            endDate: model.endDate,
            semesterID: model.semesterID,
            recurrenceInfo: angular.copy(model.recurrenceInfo),
            recurrenceType: model.recurrenceType
        };

        courseScheduleSvc.expandRecurrencePattern(
            lastExpanded).$promise.then(function (data) {
                $scope.lessons.length = 0;
                $scope.lessons.push.apply($scope.lessons, data);

                if ($scope.lessonsGridSettings.gridInstance) {
                    $timeout(function () {
                        //$scope.lessonsGridSettings.gridInstance.refresh();
                        $scope.lessonsGridSettings.gridInstance.selectAll().then(function () {
                            _.forEach(holidays, async function (h){
                                let lesson = _.find($scope.lessons, function (l) {
                                    return moment(l.startDate).startOf('day').isSame(h);
                                });
                                if (!!lesson) {
                                    await $scope.lessonsGridSettings.gridInstance.deselectRows([lesson.courseScheduleID]);
                                }
                            });
                        });


                        $scope.recurrenceExpanded = true;
                        $scope.isBusy = false;
                    }, 300);
                } else {
                    $scope.recurrenceExpanded = true;
                    $scope.isBusy = false;
                }
            }, function (error) {
                //$scope.isBusy = false;
            });
    }

    $scope.$watch('model', function (model) {
        let diff = moment.duration(moment(model.endDate).diff(moment(model.startDate)));

        let fdays = diff.days() ? diff.days() + 'd ' : '';
        let fhours = diff.hours() ? diff.hours() + 'h ' : '';
        let fminutes = diff.minutes() ? diff.minutes() + 'm ' : '';
        let fmonths = diff.months() ? diff.months() + 'm ' : '';
        let fyears = diff.years() ? diff.years() + 'r ' : '';

        $scope.lessonLength = fyears + fmonths + fdays + fhours + fminutes;

        if (!angular.equals(model.recurrenceInfo, lastExpanded.recurrenceInfo) ||
            !moment(model.startDate).isSame(lastExpanded.startDate) ||
            !moment(model.endDate).isSame(lastExpanded.endDate) ||
            model.recurrenceType != lastExpanded.recurrenceType) {

            if (model.startDate && model.endDate &&
                moment(model.startDate).isBefore(model.endDate)) {
                $scope.isBusy = true;
                expandRecurrence(model);
            }
        }

    }, true);

    courseRegistrationSvc.getAllForCourse(origCourseID).$promise.then(
        function (students) {
            $scope.students.length = 0;
            $scope.students.push.apply($scope.students, students);
            

            let newRecurrenceModel = courseScheduleSvc.createNew($scope.model, true, function () {
                $scope.model.startDate = newRecurrenceModel.startDate;
                $scope.model.endDate = newRecurrenceModel.endDate;
                $scope.model.recurrenceInfo = newRecurrenceModel.recurrenceInfo;
                $scope.model.recurrenceType = newRecurrenceModel.recurrenceType;
                $scope.editRecurrence = true;
            });

            if ($scope.studentsGridSettings.gridInstance) {
                $timeout(function () {
                    $scope.studentsGridSettings.gridInstance.refresh().then(function () {
                        $scope.studentsGridSettings.gridInstance.selectAll().then(function () {
                            expandRecurrence($scope.model);
                            $scope.studentsLoaded = true;
                            $scope.isBusy = false;
                        });
                    });
                }, 300);
            } else {
                $scope.studentsLoaded = true;
                $scope.isBusy = false;
            }
        },
        function (error) {
            $scope.isBusy = false;
        });

    $scope.modelOrig = angular.copy($scope.model);

    $scope.onStartDateChanged = function (startDate) {
        courseScheduleSvc.updateEventByStartDate($scope.model, startDate);
    }

   // $scope.model.pictures = [];

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    function saveImpl(data) {
        $scope.isSaving = true;

        var dataToSave = angular.copy(data);
        var selectedStudents = $scope.studentsGridSettings.gridInstance.getSelectedRowsData();
        var studentIDs = _.map(selectedStudents, 'studentID');
        dataToSave.studentIDs = studentIDs;

        var selectedLessons = $scope.lessonsGridSettings.gridInstance.getSelectedRowsData();
        var lessons = _.map(selectedLessons, 'startDate');
        dataToSave.lessons = lessons;

        courseSvc.courseCopySave(dataToSave, success, error);

        function success() {
            $scope.$hide();
            if (!!$scope.onCourseCopySave) {
                $scope.onCourseCopySave();
            }
        }

        function error(data) {
            $scope.detailError = data;
            $scope.isSaving = false;
        }
    }

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRMATION',
            message: $translate.instant('TXT_CONFIRM_COURSE_COPY'),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_SAVE',
                callback: function () { saveImpl(data); }
            }]
        });
    }

    $scope.teacherFromNowOnShouldShow = function () {
        return false;
    }

    $scope.recurrence = {
        type: 1
    };

    $scope.enableZoomIntegration = tenantSettingSvc.settings.enableZoomIntegration;
    $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;

    $scope.detailTabs = [
    {
        title: 'TXT_MAIN',
        template: "courses/courses/detail-main-tab.html"
    }, {
        title: 'TXT_PRICE_TAB',
        template: "courses/courses/detail-price-tab.html"
    }, {
        title: 'TXT_COMPENSATION',
        template: "courses/courses/detail-compensation-tab.html"
    }, {
        title: 'TXT_COMPENSATION_GROUPS',
        template: "courses/courses/detail-compensation-groups-tab.html"
    }, {
        title: 'TXT_LBL_SETTING',
        template: "courses/courses/detail-settings-tab.html"
    }, {
        title: 'TXT_LBL_DESCRIPTION',
        template: "courses/courses/detail-description-tab.html"
    }, {
        title: 'TXT_LBL_PICTURES',
        template: "courses/courses/detail-pictures-tab.html"
    }, {
        title: 'TXT_LBL_FILES',
        template: "courses/courses/detail-protected-storage-tab.html"
    }, {
        title: 'TXT_LBL_RECURRENCE',
        template: "schedule/schedule/schedule-course-detail-recurrence-tab.html"
    }, {
        title: 'TXT_LBL_COURSE_SCHEDULE',
        template: "courses/courses/copy-detail-lessons-tab.html"
    }, {
        title: 'TXT_LBL_STUDENTS',
        template: 'courses/courses/copy-detail-students-tab.html'
    }];

    if (tenantSettingSvc.settings.enableAmortizationSchedules) {
        var index = _.findIndex($scope.detailTabs, { 'title': 'TXT_COMPENSATION' });

        $scope.detailTabs.splice(index, 0, {
            title: 'TXT_TAB_AMORTIZATION_SCHEDULE',
            template: "courses/courses/detail-amortization-schedule-tab.html"
        });        
    }


    $scope.detailTabs.activeTab = 0;

    $scope.onDeletePictureBtnClick = function (picture) {
        _.remove($scope.model.pictures || [], { imageUri: picture.imageUri });
    }

    $scope.showPictureSelect = function () {
        picturesSelectDlgPromise.$promise.then(function () {
            picturesSelectDlgPromise.$scope.onPicturesSelected = function (pictures) {

                if (!$scope.model.pictures) {
                    $scope.model.pictures = [];
                }

                angular.forEach(pictures, function (p) {
                    if (!_.find($scope.model.pictures, { imageUri: p.imageUri }))
                    {
                        $scope.model.pictures.push(p);
                    }
                });
            };
            picturesSelectDlgPromise.show();
        });
    }

    var picturesSelectDlgPromise = $modal({
        templateUrl: 'storage/pictures/pictures-select-dlg.html',
        show: false,
        scope: $scope.$new()
    });

    $scope.addAmortizationSchedule = function() {
        $scope.model.amortizationSchedules.push({
            amount: null,
            percentageAmount: null,
            issueAt: null,
            issueDaysAfterRegistration: $scope.model.amortizationSchedules.length == 0 ? 0 : null
        });
    }

    $scope.removeAmortizationSchedule = function (schedule) {
        var index = _.indexOf($scope.model.amortizationSchedules, schedule);
        if (index > -1) {
            $scope.model.amortizationSchedules.splice(index, 1);
        }
    }

    $scope.lessonsGridSettings = {
        name: 'lessons',
        keyExpr: 'courseScheduleID',
        columns: [
            { dataFiled: 'courseScheduleID', dataType: 'number', visible: false },
            { dataField: 'startDate', caption: $translate.instant('TXT_LBL_START_DATE'), dataType: 'date', format: { raw: "dd.MM.yy EEE HH:mm" }, width: '130px', sortOrder: 'asc' },
            { dataField: 'endDate', caption: $translate.instant("TXT_LBL_END_DATE"), dataType: 'date', format: { raw: "HH:mm" } },
        ],
        selection: {
            mode: 'multiple'
        },
        onContentReady: function() {
          //  $scope.lessonsGridSettings.gridInstance.selectAll();
        }
    };

    $scope.studentsGridSettings = {
        name: 'students',
        columns: [
            { dataFiled: 'studentID', dataType: 'number', visible: false },
            { dataField: 'studentFullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', 
                sortOrder: 'asc',
                calculateSortValue: function (data) {
                    return gridSortSvc.sortHumanFullName2(data, 'studentFullName')
                } }
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.noFurtherRegisteredAttendance) {
                    e.rowElement.addClass('text-muted');
                }
            }
        },
        selection: {
            mode: 'multiple'
        },
        onContentReady: function () {
            return $scope.studentsGridSettings.gridInstance.selectAll();
        }
    }

}]);
